<template>
    <div class="registry-wrapper">
        <container-loader v-if="isLoading && !$store.getters.isLoading" />
        <div class="add-anexo">
            <div class="columns">
                <div class="file-picker-input">
                    <file-picker
                        v-if="permissao.create"
                        ref="filePicker"
                        class="upload-picker"
                        v-model="file"
                        :accepted="acceptedTypes"
                        :allowedtypes="allowedTypes"
                        @alert="showMessage"
                        :disabled="disabled"
                        returnRawFile
                    />
                </div>
                <div class="listing-header mb-4">
                    <div class="title-breadcrumb"></div>
                    <div class="header-buttons">
                        <button
                            class="save-btn"
                            type="button"
                            :disabled="!file"
                            @click="addAnexoCall"
                        >
                            {{ $t("salvar") }}
                            <button-loader :isSaving="disabled" />
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- TABELA -->
        <empty-table-message v-if="isEmpty" />

        <b-table
            v-else
            class="data-table"
            :data="anexos"
            @sort="sortTable"
            backend-sorting
        >
            <b-table-column
                v-for="(f, i) in fields"
                :key="i"
                :field="f.field"
                :label="f.key != 'excluir' ? $t(f.key) : ''"
                :class="{
                    'excluir-field': f.key == 'excluir',
                }"
                :sortable="f.sortable"
                v-slot="props"
            >
                <div v-if="f.key == 'excluir'" class="no-strike">
                    <b-field :addons="false">
                        <b-button
                            v-if="permissao.delete"
                            type="is-danger"
                            icon-right="delete"
                            @click="confirmExclusion(props.row)"
                        />
                    </b-field>
                </div>
                <div v-else-if="f.field == 'datahora'">
                    {{ props.row[f.field] | moment("L") }}
                </div>
                <div v-else-if="f.field == 'nome'">
                    {{ props.row[f.field] }}
                </div>
                <div v-else-if="f.field == 'observacao'">
                    {{ props.row[f.field] }}
                </div>
                <div
                    v-else-if="
                        f.field == 'caminho' &&
                        props.row[f.field] &&
                        ['jpg', 'jpeg', 'png'].includes(
                            props.row['nome']
                                .split('.')
                                [
                                    props.row['nome'].split('.').length - 1
                                ].toLowerCase()
                        )
                    "
                >
                    <a :href="props.row[f.field]" target="_blank">
                        <img
                            :src="props.row[f.field]"
                            class="img-anexo"
                            :title="props.row['nome']"
                            :alt="props.row['nome']"
                        />
                    </a>
                </div>
                <div v-else>
                    <a :href="props.row[f.field]" target="_blank">
                        <img
                            :src="require('@/assets/img/file.png')"
                            class="img-anexo"
                            :title="props.row['nome']"
                            :alt="props.row['nome']"
                        />
                    </a>
                </div>
            </b-table-column>
        </b-table>
        <PaginationViewer
            class="mb-0"
            :resetPagination="pagination.resetPagination"
            :totalItems="pagination.totalRows"
            :perPageOptions="pagination.perPageOptions"
            :optionStarted="pagination.optionStarted"
            @change="updatePagination"
        />
    </div>
</template>

<script>
import FilePicker from "@/components/shared/form/FilePicker";
import VendasClienteService from "@/services/VendasClienteService";
import ClienteService from "@/services/vendas/cliente/ClienteService";
import ContainerLoader from "@/components/content/loader/ContainerLoader";

export default {
    components: {
        FilePicker,
        ContainerLoader,
    },
    data() {
        return {
            service: new VendasClienteService(this.$http, this.$router),
            serviceCliente: new ClienteService(this.$http, this.$router),
            anexos: [],
            msgs: [],
            situacaoSelected: { label: "ativo", id: 1 },
            situacaoSelect: [
                { label: "ativo", id: 1 },
                { label: "inativo", id: 0 },
            ],
            fields: [
                { key: "arquivo", field: "caminho", sortable: false },
                { key: "nome-anexo-cliente", field: "nome", sortable: true },
                { key: "observacao", field: "observacao", sortable: false },
                {
                    key: "datahora-anexo-cliente",
                    field: "datahora",
                    sortable: true,
                },
                { key: "excluir", label: "", sortable: false },
            ],
            file: "",
            isRemoving: -1,
            promptedForRemoval: -1,
            allowedTypes: [
                "application/vnd.ms-excel",
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                "text/csv",
                "text/plain",
                "text/html",
                "application/pdf",
                "application/msword",
                "image/jpeg",
                "image/png",
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            ],
            acceptedTypes:
                ".xls,.xlsx,.csv,.pdf,.doc,.docx,.txt,.html,.jpeg,.jpg,.png",
            permissao: false,
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            column: "arquivo",
            order: "asc",
            fromDelete: false,
            disabled: false,
            isEmpty: false,
            isLoading: false,
            cliente: null,

            isVenda: this.$route.meta.contexto == "vendas",
            isAgro: this.$route.meta.contexto == "agro",
        };
    },
    created() {
        this.pagination.perPage =
            this.pagination.perPageOptions[this.pagination.optionStarted];

        if (this.isVenda) {
            this.permissao = this.hasPermissionAccess(
                'vendas', 
                'clientes', 
                'ven-cliente-dados-cadastrais-anexo')
        }else if(this.isAgro) {
            this.permissao = this.hasPermissionAccess( 
                'agro', 
                'clientes', 
                'agro-cliente-dados-cadastrais-anexo');
        }
        
        if (!this.permissao.read) {
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: "clientes" },
            });
        } else {
            this.carregarDados();
        }
    },
    methods: {
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;

            this.isLoading = true;

            this.findAnexos(this.$route.params.id).then((result) => {
                this.cliente = result.content;

                this.loadAnexos(
                        this.cliente.id,
                        this.cliente.idclienteerp,
                        currentPage - 1,
                        this.pagination.perPage,
                        this.column,
                        this.order,
                        this.cliente.cnpjcpf
                    )
                    .then(this.mapItems)
                    .then((value) => {
                        this.anexos = value;
                        this.isEmpty = this.anexos.length <= 0;
                    })
                    .catch((e) => {
                        this.isEmpty = true;
                        console.error("Erro ao carregar aba anexo", e);
                        this.$root.showMessage(
                            "error",
                            "msg-erro-ven-cliente-anexo-load"
                        );
                    })
                    .finally(() => {
                        this.isLoading = false;
                        if (this.fromDelete) {
                            this.isRemoving = -1;
                            this.fromDelete = false;
                        }
                    });
            });
        },
        findAnexos(id) {
            if(this.isVenda) return this.serviceCliente.findVendas(id);
            else return this.serviceCliente.findAgro(id);
        },
        loadAnexos(idCliente, idClienteErp, page, limit, column, order, cnpjcpf = "") {
            if (this.isVenda) {
                return this.service
                .loadAnexosVendas(idCliente, idClienteErp, page, limit, column, order, cnpjcpf = "");
            }else {
                return this.service
                .loadAnexosAgro(idCliente, idClienteErp, page, limit, column, order, cnpjcpf = "");
            }
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;

            return body.content.map((m) => {
                console.log(m)
                return {
                    id: m.idanexocliente,
                    caminho: m.caminho,
                    observacao: m.observacao,
                    nome: m.nome,
                    datahora: m.datahora,
                    excluir: "excluir",
                    cnpjcpf: m.cnpjcpf,
                };
            });
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados(this.pagination.currentPage);
        },
        addAnexoCall() {
            this.addAnexo({
                nome: this.$refs.filePicker.file.name,
            });
            this.file = "";
            this.$refs.filePicker.clearFile();
        },
        addAnexo(anexo) {
            anexo.idcliente = this.$route.params.id;
            anexo.cnpjcpf = this.cliente.cnpjcpf;

            this.isLoading = true;
            this.service.saveAnexo( this.$refs.filePicker.file, anexo).then((r) => {
                if (r.status != 200) {
                    console.error(`Erro ${r.status} ao salvar anexo.`);
                    console.error(`Mensagem: ${r.message}`);
                    this.$root.showMessage(
                        "error",
                        "msg-erro-ven-cliente-anexo-upload"
                    );
                } else {
                    this.anexos.push(r.content);
                    this.isEmpty = this.anexos.length <= 0;
                    this.$root.showMessage(
                        "success",
                        "msg-anexo-salvo-sucesso"
                    );
                }
            })
            .catch((_) => {
                this.$root.showMessage(
                    "error",
                    "msg-problema-realizar-acao"
                );
            })
            .finally((_) => {
                this.isLoading = false;
            });
        },
        deleteAnexo(idanexocliente) {
            this.isLoading = true;
            this.deleteAnexos(idanexocliente).then((r) => {
                this.fromDelete = true;
            })
            .finally((_) => {
                this.carregarDados();
            });
        },
        deleteAnexos(idanexocliente) {
            if (this.isVenda) return this.service.deleteAnexoVendas(idanexocliente);
            else return this.service.deleteAnexoAgro(idanexocliente);
        },
        showMessage(data) {
            this.$root.showMessage("alert", data.message);
        },
        getLabel(option) {
            if (option.label != undefined) {
                return this.$t(option.label);
            } else {
                return this.$t(option);
            }
        },
        updateSituacao(situacao) {
            if (situacao && situacao.id != null) {
                this.situacaoSelected = situacao;
            }
        },
        confirmExclusion(anexo) {
            this.promptedForRemoval = anexo.id;

            this.$root.confirm({
                message: this.$t("msg-confirmacao"),
                onConfirm: (_) => this.onExclusion(),
            });
        },
        onExclusion() {
            this.deleteAnexo(this.promptedForRemoval);
            this.isRemoving = this.promptedForRemoval;
            this.promptedForRemoval = -1;
        },
    },
};
</script>

<style lang="scss" scoped>
.file-picker-input {
    flex-grow: 1;
}

.upload-picker {
    height: 100px;
    margin: 12px;
    margin-bottom: 24px;
}
.img-anexo {
    height: 48px;
}
.data-table .ml-1 {
    margin-left: 0 !important;
}

.svg-loader {
    margin-left: 0 !important;
}

.save-btn {
    margin: 12px;
    margin-top: 24px;
}

@media only screen and (max-width: 760px) {
    .add-anexo {
        .column.is-flex {
            flex-wrap: wrap;
        }
        .save-btn {
            margin-top: 0;
        }
        .upload-picker {
            margin-bottom: 0;
        }
    }
    .svg-loader {
        margin-right: 0.5rem;
    }
}
</style>